<template>
  <div>
    <div class="d-block d-sm-none">
      <b-row class="mt-4">
        <b-col cols="4" class="text-right">
          <span class="text-uppercase">{{ $t('filter_products.order_by') }}</span>
        </b-col>
        <b-col cols="8" class="text-left">
          <b-form-select v-model="filterOrderBy" v-on:change="handleOrderChange" class="orderby-select select-green">
            <option value="none">--</option>
            <option value="lowerPrice">{{ $t('filter_products.lowest_price') }}</option>
            <option value="highestPrice">{{ $t('filter_products.highest_price') }}</option>
          </b-form-select>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="4" class="text-right">
          <span class="text-uppercase">{{ $t('filter_products.show') }}</span>
        </b-col>
        <b-col cols="8" class="text-left">
          <b-form-select v-model="perPage" v-on:change="handlePage" class="show-select select-green">
            <option value="6">6</option>
            <option value="10">10</option>
            <option value="24">24</option>
            <option value="50">50</option>
          </b-form-select>
          <span class="ml-2">{{ $t('filter_products.by_page') }}</span>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col cols="4" class="text-right">
          <span class="text-uppercase">{{ $t('filter_products.view_as') }}</span>
        </b-col>
        <b-col cols="8" class="text-left d-inline-flex align-items-center">
          <div
            class="view-type ml-1 grid"
            v-bind:class="{ active: viewType == 'grid' }"
            v-on:click="handleViewType('grid')"
          ></div>
          <div
            class="view-type ml-1 list"
            v-bind:class="{ active: viewType == 'list' }"
            v-on:click="handleViewType('list')"
          ></div>
        </b-col>
      </b-row>
    </div>
    <div class="d-none d-sm-block">
      <b-row>
        <b-col cols="12" md="5" class="d-inline-flex align-items-center my-1">
          <div v-if="allowOrdering">
            <span class="mr-2 text-uppercase">{{ $t('filter_products.order_by') }}</span>
            <b-form-select v-model="orderBy" v-on:change="handleOrderChange" class="ml-3 pt-0 pb-0 orderby-select select-green">
              <option value="none">--</option>
              <option value="lowerPrice">{{ $t('filter_products.lowest_price') }}</option>
              <option value="highestPrice">{{ $t('filter_products.highest_price') }}</option>
            </b-form-select>
          </div>
        </b-col>
        <b-col cols="12" md="4" class="d-inline-flex align-items-center my-1">
          <span class="mr-2 text-uppercase">{{ $t('filter_products.show') }}</span>
          <b-form-select v-model="perPage" v-on:change="handlePage" class="ml-3 pt-0 pb-0 show-select select-green">
            <option value="6">6</option>
            <option value="10">10</option>
            <option value="24">24</option>
            <option value="50">50</option>
          </b-form-select>
          <span class="ml-2">{{ $t('filter_products.by_page') }}</span>
        </b-col>
        <b-col cols="12" md="3" class="d-inline-flex align-items-center my-1">
          <span class="ml-md-auto mr-1 text-uppercase">{{ $t('filter_products.view_as') }}</span>
          <div
            class="view-type ml-1 grid"
            v-bind:class="{ active: viewType == 'grid' }"
            v-on:click="handleViewType('grid')"
          ></div>
          <div
            class="view-type ml-1 list"
            v-bind:class="{ active: viewType == 'list' }"
            v-on:click="handleViewType('list')"
          ></div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filterAllowOrdering: {
      type: Boolean,
      default: true,
    },
    filterOrderBy: {
      type: String,
      default: "highestPrice",
    },
    filterPerPage: {
      type: String,
      default: "24",
    },
    filterViewType: {
      type: String,
      default: "grid",
    },
  },
  data() {
    return {
      allowOrdering: this.filterAllowOrdering,
      orderBy: this.filterOrderBy,
      perPage: this.filterPerPage,
      viewType: this.filterViewType,
      totalItems: 0,
      currentPage: 1,
      loading_products: false,
      products: [],
    };
  },
  methods: {
    handleOrderChange(value) {
      this.$emit("changeOrder", value);
    },
    handlePage(value) {
      this.$emit("changePage", value);
    },
    handleViewType(value) {
      this.viewType = value;
      this.$emit("changeViewType", value);
    },
  },
  fallbackI18n: {
    messages: {
      und: {
        filter_products: {
          order_by: "Order by",
          lowest_price: "Lowest Price",
          highest_price: "Highest Price",
          show: "Show",
          by_page: "by page",
          view_as: "View as",
        },
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.view-type {
  cursor: pointer;
  height: 25px;
  width: 25px;
}

.wide-card {
  border-bottom: 1px solid $grey4-color;
}

.wide-card:last-child {
  border: 0 !important;
}

::v-deep .page-item.active .page-link {
  background-color: $corp-color2-light !important;
  border-color: $corp-color2-light !important;
  color: $white !important;
}

::v-deep .page-link {
  color: $grey5-color !important;
  margin-right: 0.5rem;
}

::v-deep .page-item:first-child .page-link,
::v-deep .page-item:last-child .page-link {
  border: 0;
}

.orderby-select {
  width: $font-size-medium * 13 !important;
}

.show-select {
  width: $font-size-medium * 4 !important;
}

@include media-breakpoint-down(sm) {
  .orderby-select {
    width: 100% !important;
  }
  .show-select {
    width: 50%;
  }
}

.grid-view {
  display: grid;
  grid-template-columns: repeat(auto-fit, $product-card-max-width);
  justify-content: space-between;
}

.velmld-spinner {
  top: 10rem !important;
}
</style>
